
import { Container, Grid, Box, Typography, } from "@mui/material";
import useGtmScrollTracker from "../hooks/useGtmScrollTracker";

function Discover() {


 const sectionRef = useGtmScrollTracker("Discover");


  return (
    <Container ref={sectionRef}>
      <Grid container spacing={4} alignItems="center">



        {/* Left Side - Text Content */}
        <Grid item xs={6} md={6}

        >
          <Box>
            <Typography
              variant="h2"
              gutterBottom
              sx={{
                fontSize: { xs: "20px", sm: "34px" },
                fontWeight: 700,
                mt: { xs: "30px", sm: "0px" },
                textAlign: "left",
                color: "#374d91",
                fontFamily: 'Poppins'
              }}
            >
              100% Secure payment
            </Typography>
            <Typography
              variant="body1"

              sx={{
                textAlign: "left",
                  fontFamily: 'Poppins',
                color: "#000000B2",
                fontSize: { xs: "12px", sm: "18px", md: "18px" },
                lineHeight: { xs: "20px", md: "28px", sm: "28px" },
                mt: 1,
              }}
            >
              Pay safely with your card. All transactions are encrypted and processed through our trusted gateway.          </Typography>
          </Box>
        </Grid>

        {/* Right Side - Image */}
        <Grid
          item
          xs={6}
          md={6}
          sx={{
            '& > .MuiGrid-item': {
              paddingLeft: '0px !important',
            }
          }}

        >
          <Box
            component="img"
            src="/homeimg/phone-4.gif"
            alt="Discover Image"
            sx={{
              width: { xs: "100%", md: "80%" },
              borderRadius: 2,
              height: { xs: "100%", md: "100%" },
              // mt: "40px",
              objectFit: "contain",
            }}
          />
        </Grid>



      </Grid>
    </Container>
  );
}

export default Discover;
